import { render } from "./ResumeSectionBoatOwnership.vue?vue&type=template&id=762526d2"
import script from "./ResumeSectionBoatOwnership.vue?vue&type=script&lang=js"
export * from "./ResumeSectionBoatOwnership.vue?vue&type=script&lang=js"

import "./ResumeSectionBoatOwnership.vue?vue&type=style&index=0&id=762526d2&lang=css"
script.render = render

export default script